import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRangePipe'
})
export class DateRangePipePipe implements PipeTransform {

  transform(start: Date | string, end: Date | string, lang: string = 'en'): string {
    if (!start || !end) return '';

    start = new Date(start);
    end = new Date(end);

    const startDay = start.getDate();
    const endDay = end.getDate();

    const getSuffix = (day: number) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    const startMonth = new Intl.DateTimeFormat(lang, { month: 'long' }).format(start);
    const endMonth = new Intl.DateTimeFormat(lang, { month: 'long' }).format(end);

    if (lang === 'en') {
      return `${startDay}${getSuffix(startDay)} of ${startMonth} - ${endDay}${getSuffix(endDay)} of ${endMonth}`;
    }

    if (lang === 'da') {
      return `${startDay}. ${startMonth} - ${endDay}. ${endMonth}`;
    }

    return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
  }

}
